import React from 'react'
import { IInvoiceProfile } from 'src/types/types';
import service from '../services/api'
const useInvoiceProfiles = () => {
  
    const [invoiceProfiles, setInvoiceProfiles] = React.useState<IInvoiceProfile[]>([]);
    const [loading, setLoading] = React.useState<boolean>(false);
    const [error, setError] = React.useState<string | null>(null);
    const [selectedProfileId, setSelectedProfileId] = React.useState<number | null>(null);

    const fetchInvoiceProfiles = async (cb?:Function) => {
        setLoading(true);
        setError(null);

        try {
            const response = await service.get('/invoice-info');
            setInvoiceProfiles(response.data);
        } catch (err: any) {
            setError(err.message || 'Failed to fetch invoice profiles');
        }
        setLoading(false);
    };


    return {
        invoiceProfiles,
        loading,
        error,
        selectedProfileId,
        setSelectedProfileId,
        fetchInvoiceProfiles,
    };
        



}

export default useInvoiceProfiles